<div class="flex justify-between header">
  <h2 color="primary">Aggiungi informazioni di bilancio</h2>
  <button mat-icon-button [mat-dialog-close]="hasSaved" aria-label="Chiudi" matTooltip="Chiudi">
    <mat-icon>clear</mat-icon>
  </button>
</div>
<app-dialog-header [denominazione]="praticaProgressService.selectedPratica?.denomination || ''"
  [praticaCode]="praticaProgressService.selectedPratica?.praticaCode || ''"></app-dialog-header>

<mat-dialog-content class="mat-elevation-z2 double-header-dialog-content">

  <section *ngFor="let item of fieldList; index as i">
    <h2>{{item.label}}</h2>
    <div class="flex flex-row items-center">
      <div style="flex: 1; margin-right: 16px;">
        <smart-form [fields]="item.fields"></smart-form>
      </div>
      <button mat-flat-button color="accent" (click)="save(i)"
        [disabled]="budgetDataFormComponentList?.get(i)?.form?.invalid">SALVA</button>
    </div>
  </section>

</mat-dialog-content>

<mat-dialog-actions align="center">

</mat-dialog-actions>
